import {useRef,useEffect, useState} from 'react';

import {Dialog} from 'primereact/dialog';
import {Button} from 'primereact/button';

import {ToastService} from '../../../../AppToast';
import {useForm} from '../../../../shared/hooks/Form';
import {ConfirmDialogService} from '../../../../AppConfirmDialog';
import  EventEmitter  from '../../../../utils/EventEmitter';
import {useTranslation} from '../../../../shared/language';
export const useDialogChangeTax = (props) => {

  const input = useRef(null);

  const {selectedItems,taxs} = props;
  const {t} = useTranslation();
  const [registerInvoiceOptions, setRegisterInvoiceOptions] = useState([]);
  const [display, setDisplay] = useState(false);
  const [sourceTaxs, setSourceTaxs] = useState([]);
  const [submitting, setSubmitting] = useState(false);

  const showChangeTaxDialog = () => {
    const _taxs = [];
    taxs.forEach(item => {
      _taxs.push({value: item.id, label: item.name});
    });
    setSourceTaxs(_taxs);
    let showDialog = true;
    if(!selectedItems || selectedItems.length == 0) {
      showDialog = false;
      ConfirmDialogService.showInvalid(t('validation.selectProductForTaxChange'));
    }
    setDisplay(showDialog);
  }

  const setRegisterInvoice = () =>{
  }

  const handleSubmit = () => {
    ConfirmDialogService.confirmChangeTax(() => {
      submitChangeTax();
    });
    
  }

  const submitChangeTax = () => {
    const changeTaxsData = getValue();
    let ids;
    if (Array.isArray(selectedItems)) {
      ids = selectedItems.map(({id}) => id);
    } else {
      ids = [selectedItems['id']];
    }
    changeTaxsData.Ids = ids;
    EventEmitter.emit("changeTaxs", changeTaxsData);
    setDisplay(false);
  }

  const {render: renderForm, setValue, getValue} = useForm({
    fields: [
      {field: 'taxId', header: t('common.applyNewTaxRate'), type: 'Dropdown', DropdownProps: {options: taxs, filter: true, resetFilterOnHide: true}, className: 'md:col-12', labelClassName: 'md:col-5', inputClassName: 'md:col-7'},
    ],
    layout: 'Horizontal'
  });

  useEffect(() => {

  },[selectedItems,taxs])

  const renderChangeTax = () => {
    return (
      <Dialog header={t('common.changeTaxRate')} visible={display} style={{width: '40rem'}} position="top" onHide={() => setDisplay(false)}>
        <div className="p-fluid formgrid grid">
          <div className="col-11">
            {renderForm()}
          </div>
        </div>

        <div className="flex justify-content-end">
          <Button label={t('common.convert')} icon="pi pi-sync" onClick={handleSubmit} loading={submitting} className="p-button-sm mr-2"/>
          <Button label={t('common.close')} icon="pi pi-times" onClick={() => setDisplay(false)} className="p-button-sm p-button-raised p-button-text p-button-plain"/>
        </div>
      </Dialog>
    );
  }

  return {renderChangeTax, showChangeTaxDialog, setValue};

}
